import { Controller } from "react-hook-form";
import type { Control, FieldValues, Path } from "react-hook-form";

import { trpc } from "@calcom/trpc/react";
import { Label, Select } from "@calcom/ui";

type Props<T extends FieldValues> = {
  officeId: number;
  name: Path<T>;
  control: Control<T>;
  instanceId: string;
};

export default function NexhealthPaymentTypeSelect<T extends FieldValues>({
  officeId,
  name,
  control,
  instanceId,
}: Props<T>) {
  const { data = [], isLoading } = trpc.viewer.office.getPaymentTypes.useQuery({ officeId });

  return (
    <div>
      <Label>Payment Type</Label>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => {
          const options = data;
          const selected =
            options.find((option) => option.value === value) ||
            (value ? { label: "Office default", value } : undefined);

          return (
            <Select
              className="w-full"
              instanceId={instanceId}
              placeholder="Select Payment Type"
              options={options}
              value={selected}
              onChange={(option) => option && onChange(option.value)}
              isLoading={isLoading}
            />
          );
        }}
      />
    </div>
  );
}
